// Axios and configuration
import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";

// Interfaces
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";
import { I_ApprovalReference } from "../interfaces";

// Constants and utilities
import approvalReferenceBoilerplate from "../constants/ApprovalReferenceBoilerplate";
import snackBar from "src/utilities/snackBar/SnackBar";

/**
 * Fetches approval reference data, including template groups, chains, statuses, and action types.
 * If the call fails, falls back to a default boilerplate object.
 *
 * @param recordTypeId - Optional ID to scope the reference data to a specific record type
 * @returns Approval reference data or a boilerplate fallback
 */
const getApprovalReference = async (
  recordTypeId?: number
): Promise<I_ApprovalReference> => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/approval/reference${
      recordTypeId !== undefined ? `?recordTypeId=${recordTypeId}` : ""
    }`;

    const response = await Axios.get<I_BaseAPIResponse<I_ApprovalReference>>(
      url,
      AxiosConfig.configValue("min")
    );

    if (response.data.HasError) {
      console.error("API Error:", response.data.ErrorMessage);

      snackBar({
        type: "error",
        text: "Failed to fetch approval reference data",
        timeout: 5000,
      });

      return approvalReferenceBoilerplate;
    }

    return response.data.Data;
  } catch (error) {
    console.error("getApprovalReference:", error);

    snackBar({
      type: "error",
      text: "Failed to fetch approval reference data",
      timeout: 5000,
    });

    return approvalReferenceBoilerplate;
  }
};

export default getApprovalReference;
